import { State, Effect, dispatch, Actions } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import setAuthorizationToken from '../utils/setAuthorizationToken'
import qs from 'qs'

const AuthState = State({
  initial: {
    isAuthenticated: false,
    token: null,
    user: null,
    isLoginBoxVisible: false
  },
  toggleLoginBox (state, isVisible) {
    return {
      isLoginBoxVisible: isVisible
    }
  },
  logged_in (state, payload) {
    window.chat_extra_params = {userId: payload.user.id, username: payload.user.username}
    return {
      isAuthenticated: true,
      token: payload.token,
      user: payload.user
    }
  },
  logout (state, payload) {
    window.localStorage.removeItem('auth')
    window.localStorage.removeItem('currentUser')
    setAuthorizationToken(null)
    return {
      isAuthenticated: false,
      token: null,
      user: null
    }
  }
})

// eslint-disable-next-line
const loginEffect = Effect('login', (userData) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.post(`${apiAddress}user/signin`, qs.stringify(userData)).then((res) => {
    window.localStorage.setItem('auth', JSON.stringify(res.data))
    setAuthorizationToken(res.data.token)
    Actions.logged_in(res.data)
    return res
  })
})

// eslint-disable-next-line
const forgetPasswordEffect = Effect('forgetPassword', (userData) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.post(`${apiAddress}user/forgot-password`, qs.stringify(userData))
})

export default AuthState



// WEBPACK FOOTER //
// ./src/states/auth.js